import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { ServicioCreateComponent } from '../servicio-create/servicio-create.component';
import { ServicioUpdateComponent } from '../servicio-update/servicio-update.component';
import { ServicioViewComponent } from '../servicio-view/servicio-view.component';
import { ServicioService } from '../servicio.service';

@Component({
  selector: 'app-servicio-index',
  templateUrl: './servicio-index.component.html',
  styleUrls: ['./servicio-index.component.scss']
})
export class ServicioIndexComponent implements OnInit {

  reloadEmitter: EventEmitter<null> = new EventEmitter();
  
  columnas: any[] = [
    {
      label: 'Nombre',
      attribute: 'nombre'
    },
    {
      label: 'Decripción',
      attribute: 'descripcion'
    },
    {
      label: 'Estado',
      styled: true,
      attribute: 'estado',
      value: (element: any) => {
        if (element.estado == 1) {
          return '<h5><span class="badge bg-primary">Activo</span></h5>';
        } else {
          return '<h5><span class="badge bg-secondary">Inactivo</span></h5>';
        }
      }
    }
  ];
  filtros: any[] = [
    {
      label: 'Nombre',
      column: 'nombre',
      op: 'substring',
      type: 'text'
    },
    {
      label: 'Estado',
      column: 'estado',
      op: 'eq',
      type: 'select',
      options: [
        {
          label: "Activo",
          value: 1
        },
        {
          label: "Inactivo",
          value: -1
        },
      ]
    }
  ];
  acciones: any[] = [
    {
      icon: "eye",
      label: "Detalles",
      action: (element: any, index: number) => {
        this.view(element);
      }
    }, {
      icon: "pen",
      label: "Modificar",
      action: (element: any, index: number) => {
        this.edit(element, index);
      }
    }, {
      icon: "toggle-on",
      label: "Desactivar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == -1
      }
    }, {
      icon: "toggle-off",
      label: "Activar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1
      }
    }
  ]
  
  constructor(
    private modalService: NgbModal,
    private service: ServicioService,
    private alerts: AlertService,
    private loading: LoadingService,
    public formatter: FormatterService,
    public config: ConfigService,
    public sesion: SesionService
  ) {}
  
  ngOnInit() {
    this.loadData();
  }
  
  loadData(){
    this.reloadEmitter.emit();
  }
  
  add() {
    const modalRef = this.modalService.open(ServicioCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static'});
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => {});
  }
  
  edit(element: any, index: number){
    const modalRef = this.modalService.open(ServicioUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static'});
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason) => {});
  }
  
  view(element: any){
    const modalRef = this.modalService.open(ServicioViewComponent, { size: 'lg', scrollable: true});
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {}, (reason: any) => {});
  }
  
  toggle(element: any){
    if(element.estado == 1){
      this.loading.show();
      this.service.deactivate(element.id).subscribe({next: (res: any) => {
        this.loading.hide();
        this.loadData();
      }, error: (err: any) => {
        this.loading.hide();
        this.alerts.addAlert("No se ha podido desactivar la Servicio.", "danger");
      }});
    } else {
      this.loading.show();
      this.service.activate(element.id).subscribe({next: (res: any) => {
        this.loading.hide();
        this.loadData();
      }, error: (err: any) => {
        this.loading.hide();
        this.alerts.addAlert("No se ha podido activar la Servicio.", "danger");
      }});
    }
  }

}
